import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import useTranslations from "../../i18n/useTranslations";
import type { Tier } from "../../types";
import ChevronButton from "../ChevronButton";
import getTierLevel from "./getTierLevel";
import TierEmblem from "./TierEmblem";
import TierNav from "./TierNav";

type Props = {
  tier: Tier;
  expandable: boolean;
  locked: boolean;
};

const TierCardHeader: FC<Props> = ({ tier, expandable, locked }) => {
  const {
    state: { currentPoints },
  } = useRewardCenter();
  const t = useTranslations();
  const { level, milestones } = getTierLevel(tier, currentPoints);
  const subtitle = locked
    ? t("reward_center.tier.locked")
    : t("reward_center.tier.level_progress", {
        level,
        total: milestones.length,
      });

  return (
    <div data-slot="tier-card-header" className="flex items-center gap-3.5">
      <TierEmblem tier={tier} locked={locked} />
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate font-bold text-xl leading-7 text-shadow-lg">
          {tier.name}
        </span>
        <span className="truncate text-sm opacity-60 text-shadow-md">
          {subtitle}
        </span>
      </span>
      <span className="flex items-center gap-2">
        <TierNav />
        {expandable && (
          <ChevronButton label={t("reward_center.tier.show_levels")} />
        )}
      </span>
    </div>
  );
};

export default TierCardHeader;
